import React, { useEffect, useRef } from 'react';
import Wrapper from './styles';
import { Filters, ProductList, Sort } from '../../components';
import { useLanguageContext } from '../../context/language_context';
import { useFilterContext } from '../../context/filter_context';
import { Link, useLocation } from 'react-router-dom';

const ProductsPage = () => {
  const { t, isArabic } = useLanguageContext();
  const { setCategoryFilter } = useFilterContext();
  const location = useLocation();
  const lastCategoryRef = useRef(null);
  
  useEffect(() => {
    document.title = 'Art & Bois | Products';
  }, []);

  useEffect(() => {
    // Get category from URL query params
    const params = new URLSearchParams(location.search);
    const categoryParam = params.get('category') || 'all';
    
    // Only update if category actually changed
    if (lastCategoryRef.current !== categoryParam) {
      lastCategoryRef.current = categoryParam;
      setCategoryFilter(categoryParam);
    }
  }, [location.search, setCategoryFilter]);

  return (
    <main style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
      <Wrapper>
        {/* Page Header */}
        <div className="page-header">
          <div style={{ maxWidth: '1440px', margin: '0 auto' }}>
            <nav className="breadcrumb">
              <Link to="/">{t.nav.home}</Link>
              <span style={{ fontSize: '0.75rem' }}>/</span>
              <span>{t.nav.products}</span>
            </nav>
            <h1>{t.products.allProducts}</h1>
          </div>
        </div>

        {/* Main Content */}
        <div className="products-container">
          <div className="products">
            <div className="filters-section">
              <Filters />
            </div>
            <div className="products-section">
              <Sort />
              <ProductList />
            </div>
          </div>
        </div>
      </Wrapper>
    </main>
  );
};

export default ProductsPage;
